export const PROJECTS_LOAD_START = "PROJECTS_LOAD_START";
export const PROJECTS_LOAD_SUCCESS = "PROJECTS_LOAD_SUCCESS";
export const PROJECTS_LOAD_FAIL = "PROJECTS_LOAD_FAIL";

export const ASSETS_LOAD_START = "ASSETS_LOAD_START";
export const ASSETS_LOAD_SUCCESS = "ASSETS_LOAD_SUCCESS";
export const ASSETS_LOAD_FAIL = "ASSETS_LOAD_FAIL";
